var Public_zh = require('../Content/css/public.less'),
	fonts = require('../Content/css/font-awesome.css'),
	zepto_touch = require('../Content/js/touch.js');
$(function() {
	var navmenu = $(".nav-menu");
	var hheight = window.innerHeight;
	var wweith = window.innerWidth;
	$("#navbar-toggle button").on('tap', function() {
		if($("button").hasClass("close")) {
			$("button").removeClass("close");
			$(".moble-nav").removeClass("active");

		} else {
			$("button").addClass("close");
			$(".moble-nav").addClass("active");
		}
		if($("#left_nav").hasClass("active")) {
			$("#left_nav").removeClass("active").addClass("close");
		}
		if($(".language_nav").hasClass("active")) {
			$(".language_nav").removeClass("active");
		}
	});
	$(".navmenu").on('tap', function() {
		if($(this).find('.nav-menu-icon').hasClass('nav-menu-rotate-back')) {
			$(this).find('.nav-menu-icon').removeClass("nav-menu-rotate-back").addClass("nav-menu-rotate");
			$(this).next(".nav-menu-li").addClass("active");
		} else {
			$(this).find('.nav-menu-icon').addClass("nav-menu-rotate-back").removeClass("nav-menu-rotate");
			$(this).next(".nav-menu-li").removeClass("active");
		}
	});
	$(".language").on('tap', function() {
		$(".language_nav").addClass("active");
		$(".moble-nav").removeClass("active");
	});
	window.addEventListener("load", function() {
		var btn = $(".foot_top");
		function goTop(acceleration, time) { //修改参数可调整返回顶部的速度
			acceleration = acceleration || 0.1;
			time = time || 10;
			var speed = 1 + acceleration;

			function getScrollTop() { //取得滚动条的竖直距离
				return document.documentElement.scrollTop || document.body.scrollTop;
			}

			function setScrollTop(value) { //设置滚动条的竖直距离,实现效果的关键就是在很短的间隔时间内不断地修改滚动条的竖直距离,以实现滚动效果
				document.documentElement.scrollTop = value;
				document.body.scrollTop = value;
			}
			window.onscroll = function() {
				var scrollTop = getScrollTop();
				if(scrollTop > 100) { //判断滚动条距离窗口顶部多远时显示出来，这里是100px
					//							btn.style.display = "block";
					btn.show();
				} else {
					//							btn.style.display = "none";
					btn.hide();
				}
			};
			btn.on('tap', function() {
				var timer = setInterval(function() {
					setScrollTop(Math.floor(getScrollTop() / speed)); //这行代码是关键，取得滚动条竖直距离，除以speed后再给滚动条设置竖直距离
					if(getScrollTop() == 0)
						clearInterval(timer);
				}, time);
			})
		}
		goTop(0.2, 8);
	}, false);

});


// WEBPACK FOOTER //
// ./E:/airwheel.net_mob/entry/common.js